import { Card, Stack, Typography } from "@mui/material";
import FieldRow from "../../../components/mobile/FieldRow";
import {
  convertDate,
  convertToINR,
  formatDotDateTimeShort,
} from "../../../helpers/Utils";
import { TOKENS } from "../constants/figmaTokens";
import {
  InvoiceStatus,
  MailingStatus,
  OrderStatus,
  POStatus,
} from "../constants/statusMapping";
import { getUTRString } from "../utils/payments";
import { getEffectivePoStatus } from "../utils/poRouting";
import OrderStatusBadge from "./OrderStatusBadge";

const captionSx = { fontSize: 12, lineHeight: "16px", color: TOKENS.onSurfaceSecondary };

export default function PoSummaryCard({ po, invoicedValue }) {
  const poStatusEntry =
    POStatus[getEffectivePoStatus(po)] ?? OrderStatus[po.order_status];
  const invoiceStatusEntry = InvoiceStatus[po.invoice_status];
  const payments = po.payments || [];

  return (
    <Card
      sx={{
        bgcolor: TOKENS.surfaceDefault,
        borderRadius: "8px",
        boxShadow: "none",
        p: "16px",
      }}
    >
      <Typography sx={{ fontSize: 16, fontWeight: 700, lineHeight: "24px", mb: 1.5 }}>
        PO details
      </Typography>
      <Stack gap={1}>
        <FieldRow label="Order Value" value={convertToINR(po.order_value)} />
        <FieldRow label="Invoice Value" value={convertToINR(invoicedValue)} />
        <FieldRow label="Vendor" value={po.vendor_name || "N/A"} />
        <FieldRow label="Project ID" value={po.project_id || "N/A"} />
        <FieldRow label="City" value={po.project_city || "N/A"} />
        {po.customer_name?.trim() && (
          <FieldRow label="Customer" value={po.customer_name} />
        )}
        <FieldRow label="Business Unit" value={po.business_unit || "N/A"} />
        {poStatusEntry && (
          <FieldRow
            label="PO Status"
            value={
              <Stack alignItems="flex-start" gap="4px">
                <OrderStatusBadge type={poStatusEntry.code} label={poStatusEntry.label} />
                {po.status_change_time && (
                  <Typography sx={captionSx}>
                    {formatDotDateTimeShort(po.status_change_time)}
                  </Typography>
                )}
              </Stack>
            }
          />
        )}
        <FieldRow
          label="Invoice Status"
          value={
            <Stack alignItems="flex-start" gap="4px">
              <OrderStatusBadge
                type={invoiceStatusEntry?.code}
                label={invoiceStatusEntry?.label}
              />
              {po.invoice_uploaded ? null : (
                <Typography sx={captionSx}>Invoice copy missing</Typography>
              )}
            </Stack>
          }
        />
        <FieldRow
          label="Total Paid"
          value={
            <Stack gap="2px">
              <Typography sx={{ fontSize: 13, lineHeight: "18px" }}>
                {convertToINR(po.total_amount_paid)}
              </Typography>
              {payments.map((payment) => (
                <Typography key={payment.id} sx={captionSx}>
                  {getUTRString(payment)}
                  {payment.payment_date ? `[${convertDate(payment.payment_date)}]` : ""}
                </Typography>
              ))}
            </Stack>
          }
        />
        <FieldRow
          label="Mailing Status"
          value={MailingStatus[po.mail_sent]?.label || "N/A"}
        />
        <FieldRow label="Advance Required" value={po.advance_required ? "Yes" : "No"} />
      </Stack>
    </Card>
  );
}
